import { Button, Divider, Grid, List, ListItem, Typography } from '@material-ui/core';
import React from 'react'
import RichTextEditor from 'react-rte';
import { NotesFlag } from './NotesFlag';
import moment from 'moment';
import { formatDate } from '../../../common/formatDate';



export const ReportNoteList = ({ id, type, notes, markRead, getNotes }: any) => {
  const [noteId, setNoteid] = React.useState(0);
  const [noteListOpen, setNoteListOpen] = React.useState(false);






  const {
    error: errorNotes,
    data: notesdata,
    isLoading: isLoadingNotes,
    isError: isErrorNotes,
  } = getNotes(id);



  if (isLoadingNotes) return <Typography>Loading notes...</Typography>;
  if (isErrorNotes) return <Typography>Error loading notes.</Typography>;
  if (!notesdata || notesdata.length === 0) return <Typography>No notes available.</Typography>;

  return (
    <>




      {notesdata.map((note: any) => (
        <>
          <Grid container
            direction="row"
            alignItems="flex-start"
            spacing={2}>

            <Grid item xs={5} style={{ marginBottom: 4, marginTop: 8 }}>
              <Typography variant="body1" display="inline">
                {note.subject}
              </Typography>
            </Grid>


            <Grid item xs={2} style={{ marginBottom: 4, marginTop: 8 }}>
              <Typography variant="body2" display="inline" align="right">
                From: {note.user_name}
              </Typography>
            </Grid>
            <Grid item xs={3} style={{ marginBottom: 4, marginTop: 8 }}>
              <Typography variant="body2" display="inline" align="right">
                At: {formatDate(note.datetime)}
              </Typography>
            </Grid>
            {/* {isNoteType(note.note_type) ? ( */}
            <Grid item xs={2} style={{ marginBottom: 4, marginTop: 8 }}>
              <Button
                variant="contained"
                fullWidth
                color="primary"
                onClick={() => {
                  setNoteid(note.id);
                  setNoteListOpen(true);
                }}
              >
                Note ({note.id})
              </Button>
            </Grid>
            {/* ) : null} */}
            <Grid item xs={12} style={{ marginBottom: 12 }}>
              <RichTextEditor
                value={RichTextEditor.createValueFromString(note.comment || '', 'markdown')}
                readOnly={true}
              />
            </Grid>
          </Grid >
          <Divider variant="fullWidth" />
        </>
      ))}






      {noteListOpen && notesdata.find((note: any) => note.id === noteId) && (
        <NotesFlag
          id={id}
          noteId={noteId}
          open={noteListOpen}
          text={notesdata.find((note: any) => note.id === noteId)}
          onClose={() => setNoteListOpen(false)}
        />
      )
      }



    </>
  )
}


